// @flow
import {List} from 'immutable';
import {Store} from 'client/framework';
import appStore from 'client/AppStore';
import teacherClassroomScopeStore from 'client/Classrooms/Classroom/Teacher/TeacherClassroomScope/TeacherClassroomScope.store';
import {mandarkEndpoint} from '@albert-io/json-api-framework/request/builder/legacy';
import type {Subject as SubjectModelV2} from 'resources/GeneratedModels/Subject/SubjectModel.v2';

class TopicsTableStore extends Store {
  _getGuideQuery(): Object {
    const attemptNumber = teacherClassroomScopeStore.getAttemptNumber();
    const selectedSubjects = teacherClassroomScopeStore.getSelectedSubjects();
    const studentId = appStore.routerProps.params.userId;
    const startDate = teacherClassroomScopeStore.getStartDate();
    const endDate = teacherClassroomScopeStore.getEndDate();

    return mandarkEndpoint(['subjects_v2'])
      .meta({
        context: {
          start_date: startDate,
          end_date: endDate
        }
      })
      .meta({
        context: {
          student: {
            id: studentId
          }
        }
      })
      .meta(
        {
          context: {
            guess: {attempt_number: attemptNumber}
          }
        },
        attemptNumber
      )
      .meta(
        {
          context: {
            guess: {
              most_recent: true
            }
          }
        },
        !attemptNumber
      )
      .filter(
        {
          id: selectedSubjects.join(','),
          guides_v1: {
            id: {
              null: false
            }
          },
          included: {
            'guides_v1.guide_levels_v2': {
              'meta.count_of_questions': {
                greater_than: 0
              }
            }
          }
        },
        !selectedSubjects.isEmpty()
      )
      .pageSize(400)
      .include('guides_v1.guide_levels_v2.subject_v2')
      .customQuery({
        with_meta: 'guide_v1,guide_level_v2'
      });
  }

  hasReceivedSubjects(): boolean {
    return this._getGuideQuery().isResourceReady();
  }

  getSubjects(): List<SubjectModelV2> {
    return this._getGuideQuery().getResource();
  }
}

export default new TopicsTableStore('TopicsTableStore');
